/*------------------------------------*\
    MODULES
\*------------------------------------*/
class Map {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.mapElem = self.elem.querySelector('[data-map]');
        self.mapItemElems = self.elem.querySelectorAll('[data-map-item]');
        self.mapItemCardElems = self.elem.querySelectorAll('[data-map-item-card]');
        self.mapItemCardCloseElems = self.elem.querySelectorAll('[data-map-item-card-close]');

        


    }

    init() {
        let self = this;
        self.initMaps();

    }

    initMaps() {
        let self = this;
        self.createListeners(self);

    }

    createListeners(self) {
        document.addEventListener('DOMContentLoaded', function () {

            self.mapItemCardCloseElems.forEach(function (mapItemCardCloseElem, index) {
                mapItemCardCloseElem.addEventListener('click', function () {
                    self.mapItemCardElems.forEach(function (cardElem) {
                        cardElem.classList.remove('is-active');

                    });

                    self.mapItemElems.forEach(function (itemElem) {
                        itemElem.classList.remove('is-active');

                    });
                });
            });

            self.mapItemElems.forEach(function (mapItemElem, index) {
                mapItemElem.addEventListener('click', function () {
                    // Remove 'is-active' class from all mapItemCardElems

                    if (!mapItemElem.classList.contains('is-active')) {
                    

                    self.mapItemCardElems.forEach(function (cardElem) {
                        cardElem.classList.remove('is-active');
                        self.mapItemCardElems[index].classList.add('is-active');

                    });

                    self.mapItemElems.forEach(function (itemElem) {
                        itemElem.classList.remove('is-active');
                        self.mapItemElems[index].classList.add('is-active');

                    });

                    // Add 'is-active' class to the corresponding mapItemCardElem

                    // Add 'is-active' class to the corresponding mapItemCardElem
                }
                else{
                    self.mapItemCardElems.forEach(function (cardElem) {
                        cardElem.classList.remove('is-active');

                    });

                    self.mapItemElems.forEach(function (itemElem) {
                        itemElem.classList.remove('is-active');

                    });
                }
                    
                });
            });
        });
    }
    
}

export default Map;